<template>
<article class="extra-bonus-more article-page">
  <Transition
    name="page-transition"
    mode="out-in"
    appear
  >
    <div
      v-if="!loading"
    >
      <div class="article-page_content common-content">
        <div class="hgroup">
          <h1 class="heading1">{{ $c('Условия программы “Экстра бонусы”') }}</h1>
        </div>
        <div class="article-page_nav">
          <ol class="ordered-list">
            <li
              class="ordered-list_item"
              v-for="(condition, index) of conditions"
              v-bind:key="`header-${index}`"
            ><a :href="`#no-${index}`" class="link">{{ condition.header }}</a></li>
          </ol>
        </div>
      </div>
      <div class="article-page_content extra-bonus-more_calc-place">
        <ExtraBonusCalc
          class="article-page_nav"
          :game="game"
          :goldRate="goldRate"
        />
      </div>
      <div class="article-page_content common-content">
        <ol>
          <li
            v-for="(condition, index) of conditions"
            v-bind:key="`body-${index}`"
            :id="`no-${index}`"
            class="ordered-list_item ordered-list_item__titled2"
            v-html="`<h2>${condition.header}</h2>${condition.body}`"
          />
        </ol>
      </div>
    </div>
    <div v-else class="extra-bonus-more_loading">
      <Spinner size="medium" color="red"  />
    </div>
  </Transition>
</article>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import Spinner from '@/common/components/Spinner.vue'
import ExtraBonusCalc from '@/components/ExtraBonus/ExtraBonusCalc'
import { namespace } from 'vuex-class'

const extraBonus = namespace('extraBonus')

@Component({
  components: {
    Spinner,
    ExtraBonusCalc
  }
})
class ExtraBonusMore extends Vue {
  @Prop({
    type: String
  }) game

  @Prop({
    type: String
  }) partner

  @extraBonus.Action('fetchConditions') fetchConditions
  @extraBonus.Action('fetchPrograms') fetchPrograms
  @extraBonus.State('conditions') conditions
  @extraBonus.State('goldRate') goldRate

  loading = true

  async mounted () {
    await this.fetchConditions(this.partner)
    await this.fetchPrograms(this.partner)
    this.loading = false
  }
}

export default ExtraBonusMore
</script>

<style lang="scss" scoped>
.extra-bonus-more  {
  padding-bottom: 50px;
  &.article-page {
    margin-bottom: 0;
  }
  .article-page_nav {
    margin-bottom: 32px;
    @include media_tablet {
      margin-bottom: 56px;
    }
  }
  &_loading {
    min-width: 100vw;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &_calc-place {
    background: #262626;
    @include media_tablet {
      background-color: transparent;
    }
  }
}
</style>
